import { batch } from 'react-redux';
import { promiseCallApi, POST_METHOD, DELETE_METHOD, REQUEST_STATUS } from '~/stores/tools/commons';
import { loginCustomer, logoutCustomer } from '~/slices/customers/index'
import { login, logout } from '~/slices/logins/index'
import { hydrate } from '~/slices/carts/cart'
import { openBar } from '~/slices/commons/snackbar'
import { submit }  from '~/slices/forms/index'


export const SubmitLogin = formData => {
  return (async dispatch => {
    const response = await promiseCallApi(`${process.env.NEXT_PUBLIC_API_BASE_URL}/api/v1/logins.json`, POST_METHOD, formData);
    if(response.status === REQUEST_STATUS.CREATED) {
      // パスワード初回設定(FMSで登録した顧客の場合) or 本人確認(FMSで登録時にメアドも登録していない場合)
      if( (response.data.path == "/login/reissue_password") || (response.data.path == "/login/authentication") ) {
        await dispatch(submit({key: response.data.path ,values: response.data }))
        response.data.error && dispatch(openBar({message: response.data.error, variant: 'error'}));
        return { status: 200, path: response.data.path }
      } else {
        // 通常のログインフロー
        if(response.data.login) {
          batch(() => {
            dispatch(login()) // flag変更
            dispatch(loginCustomer(response.data.customer)) // 顧客情報収納
            dispatch(openBar({message: 'ログインしました', variant: 'success'}));
            response.data.cart && dispatch(hydrate(response.data.cart)) // 顧客IDの入ったカートを入れる
          })
          return { status: 200, path: "/mypage" }
        } else {
          dispatch(openBar({message: 'ログインに失敗しました', variant: 'error'}));
          return { status: 400, path: "/login" }
        }
      }
    }
  });
}


// 本人確認
export const submitAuthentication = formData => {
  return (async dispatch => {
    const response = await promiseCallApi(`${process.env.NEXT_PUBLIC_API_BASE_URL}/api/v1/logins/authentication.json`, POST_METHOD, formData);
    if(response.status === REQUEST_STATUS.CREATED) {
      if(response.data.path == "/login/reissue_password") {
        // パスワード初回設定(FMSで登録した顧客の場合)
        await dispatch(submit({key: response.data.path ,values: response.data }))
        return { path: "/login/reissue_password" }
      } else {
        // 失敗
        dispatch(openBar({message: "ご入力内容でのご本人様認証に失敗しました。内容をお確かめの上、再度入力してください", variant: 'error'}));
        return { path: "/login/authentication" }
      }
    }
  });
}

export const SubmitLogout = (customer_id) => {
  return (async dispatch => {
    const response = await promiseCallApi(`${process.env.NEXT_PUBLIC_API_BASE_URL}/api/v1/logins/${customer_id}`, DELETE_METHOD);
    if(response.status === REQUEST_STATUS.OK) {
      batch(() => {
        dispatch({type: 'STORE_RESET'})
        // localStorage.removeItem('customer_token');
      })
    }
    else {

    }
    batch(() => {
      dispatch(logoutCustomer()); // infoの中は空にするだけ?
      dispatch(openBar({message: 'ログアウトしました', variant: 'success'}));
      dispatch(logout()); // flag変更
    })
  });
}
